<h2>{{ 'ICONS.COLORS' | translate }}</h2>

<ul>
  @for (color of colors; track color) {
    <li>
      <div class="icon-container">
        <i class="vitamui-icon vitamui-icon-truck {{ color }}"></i>
      </div>
      <div class="text-container text caption">{{ color }}</div>
    </li>
  }
</ul>

<div class="color-select-container">
  <h2>{{ 'ICONS.TITLE' | translate }}</h2>
  <vitamui-select
    [(ngModel)]="selectedColor"
    [placeholder]="'ICONS.SELECT_COLOR' | translate"
    [options]="colorOptions"
    [multiple]="false"
    [enableSearch]="false"
  ></vitamui-select>
</div>

<ul>
  @for (icon of icons; track icon) {
    <li>
      <div class="icon-container">
        <i class="vitamui-icon vitamui-icon-{{ icon }} {{ selectedColor }}">
          @if (coloredIcons[icon]; as paths) {
            @for (path of paths; track path) {
              <span [class]="path"></span>
            }
          }
        </i>
      </div>
      <div class="text-container text caption">{{ icon }}</div>
    </li>
  }
</ul>
